export default {
	"欢迎登录进门": "歡迎登入進門財經",
	"未注册手机号验证通过后将自动注册": "未註冊手機號驗證通過後將自動註冊",
	"验证码登录": "驗證碼登入",
	"密码登录": "密碼登入",
	"请输入手机号": "請輸入手機號",
	"请输入验证码": "請輸入驗證碼",
	"请输入手机号/邮箱/进门号": "請輸入手機號/郵箱/進門號",
	"请输入密码": "請輸入密碼",
	"登 录": "登入",
	"登录": "登入",
	"进门登录": "進門登入",
	"使用微信登录": "使用微信登入",
	"我已阅读并同意《用户协议》和《隐私政策》": "我已閱讀並同意《用戶協議》和《隱私政策》",
	"我已阅读并同意": "我已閱讀並同意",
	"阅读并同意": "閱讀並同意",
	"用户协议": "用戶協議",
	"隐私政策": "隱私政策",
	"微信授权": "微信授權",
	"获取手机号": "獲取手機號",
	"获取用户信息": "獲取用戶信息",
	"微信集成（手机号）登录": "微信集成（手機號）登入",
	"使用进门账号登录": "使用進門帳號登入",
	"服务协议与隐私政策《用户协议》和《隐私政策》": "服務協議與隱私政策《用戶協議》和《隱私政策》",
	"不同意": "不同意",
	"同意并继续": "同意並繼續",
	"获取验证码": "獲取驗證碼",
	"取消": "取消",
	"保存": "保存",
	"账号不能为空": "帳號不能為空",
	"密码不能为空": "密碼不能為空",
	"手机号不能为空": "手機號不能為空",
	"验证码不能为空": "驗證碼不能為空",
	"正在登录": "正在登入",
	"请输入8-11位的手机号码": "請輸入8-11位的手機號碼",
	"请允许授权": "請允許授權",
	"提示": "提示",
	"账号或密码错误，请重新输入": "帳號或密碼錯誤，請重新輸入",
	"密码错误次数过多，可尝试使用手机验证登录": "密碼錯誤次數過多，可嘗試使用手機驗證登入",
	"和": "和",
	"密码错误次数过多，请半小时过后登录，可选择手机验证码登录，或找回密码": "密碼錯誤次數過多，請半小時過後登入，可選擇手機驗證碼登入，或找回密碼",
	"密码错误次数过多，请半小时过后登录，可选择手机验证码登录，或登录手机APP找回密码": "密碼錯誤次數過多，請半小時過後登入，可選擇手機驗證碼登入，或登入手機APP找回密碼",
	"请输入6-20位包含字母和数字的密码": "請輸入6-20位包含字母和數字的密碼",
	"选择区号": "選擇區號",
	"验证码已经发送成功": "驗證碼已經發送成功",
	"s后重发": "s後重發",
	"服务协议与隐私政策": "服務協議與隱私政策",
	"阅读并同意《用户协议》和《隐私政策》": "閱讀並同意《用戶協議》和《隱私政策》",
	"网络较差，请稍后重试": "網絡較差，請稍後重試",
	"账号或密码错误": "帳號或密碼錯誤",
	"手机号格式错误": "手機號格式錯誤",
	"手机号码错误": "手機號碼錯誤",
	"注册成功": "註冊成功",
	"验证码不正确": "驗證碼不正確",
	"用户不存在": "用戶不存在",
	"不要频繁发送，请稍后再试": "不要頻繁發送，請稍後再試",
	"绑定成功": "綁定成功",
	"验证": "驗證",
	"验证码已经失效": "驗證碼已經失效",
	"请阅读并勾选协议": "請閱讀並勾選協議",
	"密码需包含字母和数字，长度为6-20位": "密碼需包含字母和數字，長度為6-20位",
	"密码错误次数过多，请半小时后登录，可选择手机验证码登录，或找回密码": "密碼錯誤次數過多，請半小時後登入，可選擇手機驗證碼登入，或找回密碼",
	"网络不给力，请稍后重试": "網絡不給力，請稍後重試",
	"网络请求失败": "網絡請求失敗",
	"请不要重复提交": "請不要重複提交",
	"验证码错误": "驗證碼錯誤",
	"机构投资者": "機構投資者",
	"个人投资者": "個人投資者",
	"其他机构": "其他機構",
	"请上传纸质名片/其他有效证件": "請上傳紙質名片/其他有效證件",
	"请确保名片中包含姓名、公司、职位和手机号": "請確保名片中包含姓名、公司、職位和手機號",
	"姓名": "姓名",
	"请输入真实姓名": "請輸入真實姓名",
	"公司": "公司",
	"请输入公司名称": "請輸入公司名稱",
	"职位": "職位",
	"请输入职位，如：投资经理": "請輸入職位，如：投資經理",
	"用户类型": "用戶類型",
	"请选择用户类型": "請選擇用戶類型",
	"参会号码": "參會號碼",
	"邮箱": "郵箱",
	"请输入邮箱地址": "請輸入郵箱地址",
	"手写签字": "手寫簽字",
	"添加签字": "添加簽字",
	"我已阅读并同意": "我已閱讀並同意",
	"承诺书": "承諾書",
	"提交申请": "提交申請",
	"申请提交": "申請提交",
	"提交": "提交",
	"选填": "選填",
	"活动已结束": "活動已結束",
	"活动已取消": "活動已取消",
	"备用号码": "備用號碼",
	"区号": "區號",
	"请输入号码": "請輸入號碼",
	"请输入备用号码": "請輸入備用號碼",
	"请输入分机号": "請輸入分機號",
	"是否需要外呼": "是否需要外呼",
	"如果您选择需要外呼，会议开始前系统将拨入您提交的参会手机号": "如果您選擇需要外呼，會議開始前系統將撥入您提交的參會手機號",
	"需要": "需要",
	"不需要": "不需要",
	"用户须对所提供座机号的真实性、合法性、有效性承担全部责任，用户不得随意填写他人座机号；否则进门有权立即停止提供相关服务，并由用户独自承担因此而产生的一切法律责任！": "用戶須對所提供座機號的真實性、合法性、有效性承擔全部責任，用戶不得隨意填寫他人座機號；否則進門財經有權立即停止提供相關服務，並由用戶獨自承擔因此而產生的一切法律責任！",
	"我知道了": "我知道了",
	"请填写区号": "請填寫區號",
	"请填写号码": "請填寫號碼",
	"申请参会": "申請參會",
	"申请线下参会": "申請線下參會",
	"重新提交": "重新提交",
	"姓名": "姓名",
	"请输入真实姓名": "請輸入真實姓名",
	"公司": "公司",
	"请输入公司名称": "請輸入公司名稱",
	"职位": "職位",
	"邮箱": "郵箱",
	"联系电话": "聯繫電話",
	"微信号": "微信號",
	"请输入职位，如：投资经理": "請輸入職位，如：投資經理",
	"用户类型": "用戶類型",
	"请选择用户类型": "請選擇用戶類型",
	"承诺书": "承諾書",
	"查看": "查看",
	"其他": "其他",
	"无": "無",
	"审核中": "審核中",
	"已报名": "已報名",
	"问卷描述": "問卷描述",
	"人": "人",
	"联系我们": "聯繫我們",
	"查看全部": "查看全部",
	"海报图": "海報圖",
	"上传名片": "上傳名片",
	"上传名片/有效证件": "上傳名片/有效證件",
	"上传名片后将自动填充个人信息": "上傳名片後將自動填充個人信息",
	"去上传": "去上傳",
	"接待人": "接待人",
	"未审核": "未審核",
	"资料已提交成功，请留意短信通知": "資料已提交成功，請留意短信通知",
	"审核失败": "審核失敗",
	"未通过原因请查看提示内容": "未通過原因請查看提示內容",
	"提交成功，请等待审核": "提交成功，請等待審核",
	"提交成功": "提交成功",
	"申请未通过": "申請未通過",
	"审核未通过": "審核未通過",
	"备用号码": "備用號碼",
	"区号": "區號",
	"号码": "號碼",
	"是否需要外呼": "是否需要外呼",
	"如果您选择需要外呼，会议开始前系统将拨入您提交的参会手机号": "如果您選擇需要外呼，會議開始前系統將撥入您提交的參會手機號",
	"需要": "需要",
	"不需要": "不需要",
	"用户须对所提供座机号的真实性、合法性、有效性承担全部责任，用户不得随意填写他人座机号；否则进门有权立即停止提供相关服务，并由用户独自承担因此而产生的一切法律责任！": "用戶須對所提供座機號的真實性、合法性、有效性承擔全部責任，用戶不得隨意填寫他人座機號；否則進門財經有權立即停止提供相關服務，並由用戶獨自承擔因此而產生的一切法律責任！",
	"我知道了": "我知道了",
	"会议主题": "會議主題",
	"会议时间": "會議時間",
	"审核通过": "審核通過",
	"报名成功，待主办方审核": "報名成功，待主辦方審核",
	"审核结果将以短信的方式发送，请留意": "審核結果將以短信的方式發送，請留意",
	"进入会议": "進入會議",
	"返回": "返回",
	"正在识别": "正在識別",
	"报名已结束": "報名已結束（Ends）",
	"申请不通过，点击重新提交": "申請不通過，點擊重新提交",
	"申请通过，点击参会": "申請通過，點擊參會",
	"点击参会": "點擊參會",
	"选择公司": "選擇公司",
	"没找到？点击“完成”选择已输入的公司": "沒找到？點擊「完成」選擇已輸入的公司",
	"完成": "完成",
	"历史记录": "歷史記錄",
	"确认删除全部历史记录？": "確認刪除全部歷史記錄？",
	"确定": "確定",
	"请输入公司名称": "請輸入公司名稱",
	"活动介绍": "活動介紹",
	"嘉宾介绍": "嘉賓介紹",
	"会议议程": "會議議程",
	"公司介绍": "公司介紹",
	"会议介绍": "會議介紹",
	"会议嘉宾": "會議嘉賓",
	"会议流程": "會議流程",
	"自定义栏目": "自定義欄目",
	"报名截止时间": "報名截止時間",
	"加日程": "加日程",
	"未开始": "未開始",
	"参会方式": "參會方式",
	"请输入": "請輸入",
	"请选择": "請選擇",
	"请上传": "請上傳",
	"请输入 (选填)": "請輸入（選填）",
	"请选择 (选填)": "請選擇（選填）",
	"立即注册": "立即註冊",
	"手机号注册": "手機號註冊",
	"邮箱注册": "郵箱註冊",
	"已有账号？": "已有帳號？",
	"去登录": "去登入",
	"注册": "註冊",
	"报名": "報名",
	"报名正在审批中，主办方通过后即可签到": "報名正在審批中，主辦方通過後即可簽到",
	"抱歉！您的报名申请并未通过，无法参与本次活动": "抱歉！您的報名申請並未通過，無法參與本次活動",
	"设置头像": "設置頭像",
	"更换头像": "更換頭像",
	"昵称": "暱稱",
	"欢迎注册进门": "歡迎註冊進門財經",
	"请上传图片格式文件": "請上傳圖片格式文件",
	"上传文件太大，请重新上传": "上傳文件太大，請重新上傳",
	"未选择上传图片": "未選擇上傳圖片",
	"上传文件": "上傳文件",
	"简介": "簡介",
	"请输入您的昵称": "請輸入您的暱稱",
	"请输入您的个人简介": "請輸入您的個人簡介",
	"忘记密码": "忘記密碼",
	"重置密码": "重置密碼",
	"手机号找回": "手機號找回",
	"邮箱找回": "郵箱找回",
	"下一步": "下一步",
	"密码不一致": "密碼不一致",
	"重置账号密码成功": "重置帳號密碼成功",
	"包含违规词汇": "包含違規詞彙",
	"等": "等",
	"绑定手机": "綁定手機",
	"跳过": "跳過",
	"绑定手机号成功": "綁定手機號成功",
	"请再次输入密码": "請再次輸入密碼",
	"该手机号已被注册绑定": "該手機號已被註冊綁定",
	"该邮箱已注册": "該郵箱已註冊",
	"您的手机号已经被注册了": "您的手機號已經被註冊了",
	"您的邮箱格式不正确": "您的郵箱格式不正確",
	"密码需包含数字和字母，长度为6-20位": "密碼需包含數字和字母，長度為6-20位",
	"用户昵称被占用": "用戶暱稱被佔用",
	"名": "名",
	"姓": "姓",
	"参会号码": "參會號碼",
	"箱": "箱",
	"邮": "郵",
	"公司名称": "公司名稱",
	"请输入参会姓名": "請輸入參會姓名",
	"请输入参会号码": "請輸入參會號碼",
	"请输入邮箱地址": "請輸入郵箱地址",
	"请输入公司名称（选填）": "請輸入公司名稱（選填）",
	"请填写参会号码或邮箱": "請填寫參會號碼或郵箱",
	"请填写正确的参会号码": "請填寫正確的參會號碼",
	"请填写正确的邮箱": "請填寫正確的郵箱",
	"您暂无观看权限": "您暫無觀看權限",
	"天": "天",
	"小时": "小時",
	"时": "時",
	"分": "分",
	"秒": "秒",
	"距离会议开始": "距離會議開始",
	"直播即将开始": "直播即將開始",
	"正在直播": "正在直播",
	"本场路演结束，感谢参与": "本場路演結束，感謝參與",
	"「投研秘书」为您提供章节点播与内容纪要服务": "「投研秘書」為您提供章節點播與內容紀要服務",
	"投研秘书": "投研秘書",
	"付费": "付費",
	"试听": "試聽",
	"已关注": "已關注",
	"关注": "關注",
	"路演介绍": "路演介紹",
	"占位符": "佔位符",
	"会议日程": "會議日程",
	"版权声明": "版權聲明",
	"为您提供章节点播与内容纪要等服务": "為您提供章節點播與內容紀要等服務",
	"路演章节": "路演章節",
	"路演文档": "路演文檔",
	"本场路演投研秘书服务": "本場路演投研秘書服務",
	"继续支付": "繼續支付",
	"购买": "購買",
	"相关路演": "相關路演",
	"我也是有底线的": "我也是有底線的",
	"本场路演不支持提问": "本場路演不支持提問",
	"提问": "提問",
	"购买会员": "購買會員",
	"占位专用": "佔位專用",
	"重新报名": "重新報名",
	"重新认证": "重新認證",
	"已提交报名，请等待审核": "已提交報名，請等待審核",
	"已提交机构投资者认证，请等待审核": "已提交機構投資者認證，請等待審核",
	"购买完成": "購買完成",
	"暂无提问": "暫無提問",
	"请先登录账号": "請先登錄帳號",
	"请先登录进门账号": "請先登錄進門帳號",
	"请先购买后观看": "請先購買後觀看",
	"私密类型路演暂不支持此操作": "私密類型路演暫不支持此操作",
	"路演准备中，请稍候查看": "路演準備中，請稍候查看",
	"添加关注成功": "添加關注成功",
	"已取消关注": "已取消關注",
	"报名审核中，请稍后": "報名審核中，請稍後",
	"报名审核中": "報名審核中",
	"报名审核通过": "報名審核通過",
	"报名审核未通过": "報名審核未通過",
	"报名审核未通过，请重新报名": "報名審核未通過，請重新報名",
	"活动报名已结束": "活動報名已結束",
	"观看权限已过": "觀看權限已過",
	"认证机构投资者": "認證機構投資者",
	"认证审核通过": "認證審核通過",
	"认证审核未通过": "認證審核未通過",
	"认证审核中，请稍后": "認證審核中，請稍後",
	"应主办方要求，本次会议不保留回放": "應主辦方要求，本次會議不保留回放",
	"查看详情": "查看詳情",
	"购买专栏": "購買專欄",
	"路演结束后发布，请稍后": "路演結束後發布，請稍後",
	"文字路演": "文字路演",
	"抱歉，本场路演暂不支持提问": "抱歉，本場路演暫不支持提問",
	"回放生成中，请稍后关注": "回放生成中，請稍後關注",
	"嘉宾正在准备路演，请稍等": "嘉賓正在準備路演，請稍等",
	"即将开始": "即將開始",
	"添加收藏成功": "添加收藏成功",
	"已取消收藏": "已取消收藏",
	"参数错误": "參數錯誤",
	"进门路演会议": "進門財經路演會議",
	"路演时间": "路演時間",
	"点击链接参与": "點擊鏈接參與",
	"购买后可观看": "購買後可觀看",
	"当前路演": "當前路演",
	"牛币": "牛幣",
	"续费至": "續費至",
	"详情": "詳情",
	"问答": "問答",
	"文档": "文檔",
	"详情介绍": "詳情介紹",
	"相关路演": "相關路演",
	"课程目录": "課程目錄",
	"专栏目录": "專欄目錄",
	"路演": "路演",
	"万": "萬",
	"暂停销售": "暫停銷售",
	"该路演暂停销售": "該路演暫停銷售",
	"起": "+",
	"限时免费": "限時免費",
	"确认购买": "確認購買",
	"课程": "課程",
	"购买课程": "購買課程",
	"仅购买本场路演": "僅購買本場路演",
	"个月": "個月",
	"长期有效": "長期有效",
	"请下载 “进门” APP 购买": "請下載「進門財經」APP 購買",
	"知道了": "知道了",
	"已购买该专栏": "已購買該專欄",
	"已购买该课程": "已購買該課程",
	"该课程暂停销售": "該課程暫停銷售",
	"打开 APP": "打開 APP",
	"打开 APP，精彩路演会议不容错过": "打開 APP，精彩路演會議不容錯過",
	"打开 APP，进行举手语音提问吧": "打開 APP，進行舉手語音提問吧",
	"打开 APP，参与路演会议体验更顺畅": "打開 APP，參與路演會議體驗更順暢",
	"搜索": "搜索",
	"下载 APP": "下載 APP",
	"首页": "首頁",
	"下载进门 APP，查看更多精彩内容": "下載進門財經 APP，查看更多精彩內容",
	"立即下载": "立即下載",
	"请输入关键字": "請輸入關鍵字",
	"确认": "確認",
	"暂无文档": "暫無文檔",
	"密码输入错误，请重新输入": "密碼輸入錯誤，請重新輸入",
	"' 你已被提升为 ' 嘉宾 ' 身份 '": "你已被提升為「嘉賓」身份",
	"你已被取消 ' 嘉宾 ' 身份": "你已被取消「嘉賓」身份",
	"本场路演仅可提问": "本場路演僅可提問",
	"您的账号已在其他地方登录": "您的帳號已在其他地方登入",
	"该路演已被主讲删除": "該路演已被主講刪除",
	"未直播": "未直播",
	"直播已开始，点击播放": "直播已開始，點擊播放",
	"你已被限制观看本场路演，可联系主讲人申请观看": "你已被限制觀看本場路演，可聯繫主講人申請觀看",
	"在这里输入聊天内容": "在這裡輸入聊天內容",
	"本场路演暂不支持提问": "本場路演暫不支持提問",
	"本场路演仅支持提问": "本場路演僅支持提問",
	"在这里输入提问内容": "在這裡輸入提問內容",
	"宣传片": "宣傳片",
	"直播尚未开始，请先观看宣传片": "直播尚未開始，請先觀看宣傳片",
	"直播尚未开始，可先观看相关宣传视频，是否播放？": "直播尚未開始，可先觀看相關宣傳視頻，是否播放？",
	"往期回放": "往期回放",
	"点击刷新": "點擊刷新",
	"刷新完成": "刷新完成",
	"视频加载失败": "視頻加載失敗",
	"网络不稳定": "網絡不穩定",
	"努力加载中": "努力加載中",
	"加载中": "加載中",
	"正在播放中": "正在播放中",
	"您终止了播放": "您終止了播放",
	"网络错误": "網絡錯誤",
	"解码错误": "解碼錯誤",
	"无效的地址": "無效的地址",
	"快进": "快進",
	"快退": "快退",
	"倍数": "倍數",
	"断开连接，重连中": "斷開連接，重連中",
	"当前未直播，请稍后关注": "當前未直播，請稍後關注",
	"路演未开始，请稍后关注": "路演未開始，請稍後關注",
	"您已连接 PPT 同步": "您已連接 PPT 同步",
	"您已断开 PPT 同步": "您已斷開 PPT 同步",
	"请输入直播厅密码": "請輸入直播廳密碼",
	"根据举办方要求": "根據舉辦方要求",
	"本场为内部交流，不对外开放": "本場為內部交流，不對外開放",
	"实名认证申请通过即可观看": "實名認證申請通過即可觀看",
	"实名认证": "實名認證",
	"该账号已在其他设备登录，为保证账号安全，请重新登录": "該帳號已在其他設備登入，為保證帳號安全，請重新登入",
	"您的账户在另一地点登录": "您的帳戶在另一地點登入",
	"重新登录": "重新登入",
	"立即认证": "立即認證",
	"审核不通过": "審核不通過",
	"撤回了一条消息": "撤回了一條消息",
	"发了个红包": "發了個紅包",
	"立即查看": "立即查看",
	"打赏了": "打賞了",
	"您有 1 条新回复": "您有 1 條新回覆",
	"我的提问": "我的提問",
	"已上墙": "已上牆",
	"待上墙": "待上牆",
	"您已被禁言": "您已被禁言",
	"输入内容为空": "輸入內容為空",
	"提问成功，请在提问列表查看": "提問成功，請在提問列表查看",
	"问": "問",
	"继续访问外部链接？": "繼續訪問外部鏈接？",
	"关闭": "關閉",
	"是": "是",
	"下载进门 APP 抢红包": "下載進門財經 APP 搶紅包",
	"下载进门 APP 查看文件": "下載進門財經 APP 查看文件",
	"昨天": "昨天",
	"查看更多": "查看更多",
	"正在加载": "正在加載",
	"暂无内容": "暫無內容",
	"发送": "發送",
	"无对应回放音视频": "無對應回放音視頻",
	"购买后可观看路演": "購買後可觀看路演",
	"下载中": "下載中",
	"已下载": "已下載",
	"下载": "下載",
	"章节": "章節",
	"此路演暂无章节信息": "此路演暫無章節信息",
	"回放已下载到我的文件": "回放已下載到我的文件",
	"回放正在下载到我的文件": "回放正在下載到我的文件",
	"此路演暂不可下载": "此路演暫不可下載",
	"播放签到失败": "播放簽到失敗",
	"数据请求中": "數據請求中",
	"没有播放地址，却没有签到失败": "沒有播放地址，卻沒有簽到失敗",
	"次播放": "次播放",
	"次浏览": "次瀏覽",
	"回放": "回放",
	"置顶": "置頂",
	"有效期": "有效期",
	"移出会议": "移出會議",
	"讲": "講",
	"预约成功，可在日历菜单查看": "預約成功，可在日曆菜單查看",
	"已取消路演会议预约": "已取消路演會議預約",
	"会议已结束，请稍后观看回放": "會議已結束，請稍後觀看回放",
	"会议已结束，本场会议不提供回放": "會議已結束，本場會議不提供回放",
	"预约失败": "預約失敗",
	"永久有效": "永久有效",
	"报名审批中": "報名審批中",
	"报名不通过": "報名不通過",
	"报名已通过": "報名已通過",
	"报名已截止": "報名已截止",
	"现场报名已截止": "現場報名已截止",
	"报名成功": "報名成功",
	"我": "我",
	"应举办方要求需签署承诺书，方可观看": "應舉辦方要求需簽署承諾書，方可觀看",
	"确 定": "確定",
	"我已经加载完了": "我已經加載完了",
	"当前没有消息": "當前沒有消息",
	"暂无数据": "暫無數據",
	"下拉刷新": "下拉刷新",
	"释放加载": "釋放加載",
	"正刷新中": "正刷新中",
	"刷新成功": "刷新成功",
	"正在努力加载": "正在努力加載",
	"已预约": "已預約",
	"预约": "預約",
	"预告": "預告",
	"直播": "直播",
	"报名": "報名",
	"预约成功，可在 “我的路演” 或 “进门 APP 日历” 菜单中查看": "預約成功，可在「我的路演」或「進門財經 APP 日曆」菜單中查看",
	"下载回放": "下載回放",
	"打开 “进门” APP，下载回放观看，精彩路演不错过！": "打開「進門財經」APP，下載回放觀看，精彩路演不容錯過！",
	"网络异常，请检查后重试": "網絡異常，請檢查後重試",
	"直播中": "直播中",
	"提交参会信息后，即可进入会议": "提交參會信息後，即可進入會議",
	"参会信息": "參會信息",
	"路演回放": "路演回放",
	"路演厅": "路演廳",
	"分析师直播": "分析師直播",
	"路演详情": "路演詳情",
	"进门": "進門財經",
	"个": "個",
	"点击可切换至 PPT 模式": "點擊可切換至 PPT 模式",
	"预约成功": "預約成功",
	"当前路演直播已开始": "當前路演直播已開始",
	"当前路演已发回放": "當前路演已發回放",
	"观看回放": "觀看回放",
	"嘉宾正在准备路演，请稍后": "嘉賓正在準備路演，請稍後",
	"会议已结束": "會議已結束",
	" 本场路演仅针对白名单客户开放 ": " 本場路演僅針對白名單客戶開放 ",
	" 本场路演需购买课程后才能观看 ": " 本場路演需購買課程後才能觀看 ",
	" 本场路演需报名审核通过才能参会 ": " 本場路演需報名審核通過才能參會 ",
	" 本场路演需购买专栏后才能观看 ": " 本場路演需購買專欄後才能觀看 ",
	" 本场路演需购买会员后才能观看 ": " 本場路演需購買會員後才能觀看 ",
	" 本场路演需购买后才能观看 ": " 本場路演需購買後才能觀看 ",
	" 本场路演需完成机构投资者认证才能参会 ": " 本場路演需完成機構投資者認證才能參會 ",
	" 预约成功，可在 “我的路演” 或 “进门APP 日历” 菜单中查看 ": " 預約成功，可在「我的路演」或「進門財經APP 日曆」菜單中查看 ",
	" 应小程序要求，该路演请前往进门 APP观看 ": " 應小程序要求，該路演請前往進門財經 APP觀看 ",
	"立即购买": "立即購買",
	"机构通": "機構通",
	"私密": "私密",
	"专场": "專場",
	"会员": "會員",
	"付费": "付費",
	"报名参会": "報名參會",
	"路演准备中，可先观看相关宣传视频，是否播放？": "路演準備中，可先觀看相關宣傳視頻，是否播放？",
	"请稍等，路演会议即将开始": "請稍等，路演會議即將開始",
	"路演会议": "路演會議",
	"路演主题": "路演主題",
	"主讲人": "主講人",
	"主持人": "主持人",
	"嘉宾": "嘉賓",
	"免责声明": "免責聲明",
	"路演准备中，准备完毕后会将您接入路演厅中": "路演準備中，準備完畢後會將您接入路演廳中",
	"你没有参会权限，请退出重试": "你沒有參會權限，請退出重試",
	"网络异常，请检查网络设置，或尝试重新入会。": "網絡異常，請檢查網絡設置，或嘗試重新入會。",
	"离开会议": "離開會議",
	"重新入会": "重新入會",
	"网络异常，请稍后再试": "網絡異常，請稍後再試",
	"问题征集": "問題徵集",
	"获取邀请函": "獲取邀請函",
	"请输入提问内容": "請輸入提問內容",
	"暂不支持此类会议": "暫不支持此類會議",
	"会议不允许预提问": "會議不允許預提問",
	"提问": "提問",
	"提问已关闭": "提問已關閉",
	"问题征集已关闭": "問題徵集已關閉",
	"还可输入": "還可輸入",
	"字": "字",
	"扫一扫观看路演": "掃一掃觀看路演",
	"问题提交成功，感谢您的关注": "問題提交成功，感謝您的關注",
	"进行中": "進行中",
	"已结束": "已結束",
	"待开始": "待開始",
	"已取消": "已取消",
	"活动时间": "活動時間",
	"举办方": "舉辦方",
	"联系人": "聯繫人",
	"活动地址": "活動地址",
	"线下": "線下",
	"线上": "線上",
	"线上 + 线下": "線上 + 線下",
	"立即报名": "立即報名",
	"活动详情": " 活動詳情",
	"咨询": "咨詢",
	"日历": "日曆",
	"活动地点及联系人线下报名成功后可见": "活動地點及聯繫人線下報名成功後可見",
	"参会密码": "參會密碼",
	"晚宴介绍": "晚宴介紹",
	"进门号": "進門號",
	"报名通过后可见": "報名通过後可見",
	"活动已截止": "活動已截止",
	"进门 APP/H5 / 小程序": "進門財經 APP/H5 / 小程序",
	"PC 端": "PC 端",
	"电话接入": "電話接入",
	"报名参与上市公司调研活动": "報名參與上市公司調研活動",
	"审批中": "審批中",
	"观看路演": "觀看路演",
	"参与路演": "參與路演",
	"报名审核已通过，请按时参加": "報名審核已通過，請按時參加",
	"活动报名时间已截止！": "活動報名時間已截止！",
	"报名失败": "報名失敗",
	"主办方": "主辦方",
	"活动": "活動",
	"地址": "地址",
	"请上传纸质名片": "請上傳紙質名片",
	"必填": "必填",
	"请输入身份证号": "請輸入身份證號",
	"您的报名已提交，审核通过后将自动签到": "您的報名已提交，審核通過後將自動簽到",
	"签到": "簽到",
	"活动签到": "活動簽到",
	"识别失败，请重新上传或手动填写": "識別失敗，請重新上傳或手動填寫",
	"调研活动不存在": "調研活動不存在",
	"获取地理位置失败，请重新授权": "獲取地理位置失敗，請重新授權",
	"已成功提交报名，请耐心等待报名结果通知": "已成功提交報名，請耐心等待報名結果通知",
	"已完成登记报名，请完成活动签到": "已完成登記報名，請完成活動簽到",
	"该活动仅限机构投资者参加，请前往认证": "該活動僅限機構投資者參加，請前往認證",
	"您填写的公司属于 “": "您填寫的公司屬於「",
	"”，与选择的用户类型不一致，是否修改成一致并提交": "」，與選擇的用戶類型不一致，是否修改成一致並提交",
	"忽略并提交": "忽略並提交",
	"修改并提交": "修改並提交",
	"机构投资者公司": "機構投資者公司",
	"分析师研究所": "分析師研究所",
	"上市公司董监高公司": "上市公司董監高公司",
	"您提交的公司": "您提交的公司",
	"与您认证的": "與您認證的",
	"不一致": "不一致",
	"为确保您的参会权限，请您及时更新": "為確保您的參會權限，請您及時更新",
	"认证信息": "認證信息",
	"温馨提示": "溫馨提示",
	"去更新": "去更新",
	"忽略": "忽略",
	"请选择您的类型": "請選擇您的類型",
	"公募": "公募",
	"私募": "私募",
	"其他": "其他",
	"保险公司": "保險公司",
	"信托公司": "信託公司",
	"券商资管": "券商資管",
	"券商自营": "券商自營",
	"期货公司": "期貨公司",
	"银行": "銀行",
	"券商研究所": "券商研究所",
	"境外机构": "境外機構",
	"银行理财": "銀行理財",
	"报名限额": "報名限額",
	"签到成功": "簽到成功",
	"活动已取消，暂不支持签到": "活動已取消，暫不支持簽到",
	"您的活动报名审核中，不支持签到": "您的活動報名審核中，不支持簽到",
	"您的活动报名审核未通过，不支持签到": "您的活動報名審核未通過，不支持簽到",
	"活动已过期，不支持签到": "活動已過期，不支持簽到",
	"活动已完成，不支持签到": "活動已完成，不支持簽到",
	"行业": "行業",
	"您的报名已通过，可直接入会": "您的報名已通過，可直接入會",
	"会议活动已失效": "會議活動已失效",
	"您已在白名单内，可直接入会": "您已在白名單內，可直接入會",
	"会前问题收集": "會前問題收集",
	"请输入您想了解的问题": "請輸入您想了解的問題",
	"基本信息": "基本訊息",
	"其他信息": "其他資訊",
	"报名券商": "報名券商",
	"是否外呼": "是否外呼",
	"承诺书签署": "承諾書簽署",
	"删除": "刪除",
	"重写": "重寫",
	"名片信息已自动填充": "名片信息已自動填充",
	"重新上传": "重新上傳",
	"名片内容信息识别": "名片內容信息識別",
	"成功": "成功",
	"失败": "失敗",
	"名片内容信息识别成功": "名片內容信息識別成功",
	"名片内容信息识别失败": "名片內容信息識別失敗",
	"您所预约调研的公司": "您所預約調研的公司",
	"此页面帮助上市公司提前收集会议问题，将会统一在会议中答复": "此頁面幫助上市公司提前收集會議問題，將會統一在會議中答覆",
	"中国标准时间 - 北京": "中國標準時間 - 北京",
	"请在空区域横向手写": "請在空區域橫向手寫",
	"重写": "重寫",
	"确定保存该签名": "確定保存該簽名",
	"取消": "取消",
	"删除": "刪除",
	"添加签名": "添加簽名",
	"确定签名即代表您已阅读全部签署文件且同意本次签名，是否确认提交？": "確定簽名即代表您已閱讀全部簽署文件且同意本次簽名，是否確認提交？",
	"本次会议需要您签署承诺书，签名代表您已阅读并同意": "本次會議需要您簽署承諾書，簽名代表您已閱讀並同意",
	"去签名": "去簽名",
	"确认签名": "確認簽名",
	"签名即代表您已阅读并同意": "簽名即代表您已閱讀並同意",
	"请在空区域横向手写": "請在空區域橫向手寫",
	"重写": "重寫",
	"确定": "確定",
	"确认": "確認",
	"确定保存该签名": "確定保存該簽名",
	"取消": "取消",
	"删除": "刪除",
	"添加签名": "添加簽名",
	"请签署清晰的签名，以确保签名的准确性": "請簽署清晰的簽名，以確保簽名的準確性",
	"确定签名即代表您已阅读全部签署文件且同意本次签名，是否确认提交？": "確定簽名即代表您已閱讀全部簽署文件且同意本次簽名，是否確認提交？",
	"本次会议需要您签署承诺书，签名代表您已阅读并同意": "本次會議需要您簽署承諾書，簽名代表您已閱讀並同意",
	"去签名": "去簽名",
	"确认签名": "確認簽名",
	"在此签名": "在此簽名",
	"返回活动": "返回活動",
	"更多": "更多",
	"您可以通过以下方式联系我们": "您可以通過以下方式聯繫我們",
	"签到信息": "簽到信息",
	"签到时间": "簽到時間",
	"预提问": "預提問",
	"为充分尊重投资者、提升公司与投资者之间的交流效率，敬请广大投资者在会议开始前提交您所关注的问题，便于公司针对投资者普遍关注的问题进行集中回答": "為充分尊重投資者、提升公司與投資者之間的交流效率，敬請廣大投資者在會議開始前提交您所關注的問題，便於公司針對投資者普遍關注的問題進行集中回答",
	"今天": "今天",
	"选择预约开始时间": "選擇預約開始時間",
	"存在必填项未填写，请填写后再进行提交": "存在必填項未填寫，請填寫後再進行提交",
	"未上传名片，请上传后再进行提交": "未上傳名片，請上傳後再進行提交",
	"未上传名片 / 有效证件，请上传后再进行提交": "未上傳名片 / 有效證件，請上傳後再進行提交",
	"姓名未填写，请填写后再进行提交": "姓名未填寫，請填寫後再進行提交",
	"公司未填写，请填写后再进行提交": "公司未填寫，請填寫後再進行提交",
	"职位未填写，请填写后再进行提交": "職位未填寫，請填寫後再進行提交",
	"请先签字确认您已阅读并同意承诺书": "請先簽字確認您已閱讀並同意承諾書",
	"请先勾选确认您已阅读并同意承诺书": "請先勾選確認您已閱讀並同意承諾書",
	"我已阅读并同意签署承诺书": "我已閱讀並同意簽署承諾書",
	"同意": "同意",
	"报名成功，待审核": "報名成功，待審核",
	"审核不通过": "審核不通過",
	"审核结果将以短信的形式通知，请留意": "審核結果將以短信的形式通知，請留意",
	"您可在报名通过后点击会议链接参会或查看其他参会方式": "您可在報名通過後點擊會議鏈接參會或查看其他參會方式",
	"请输入其他选项内容（必填）": "請輸入其他選項內容（必填）",
	"上传失败，文件大小不能超过 500M": "上傳失敗，文件大小不能超過 500M",
	"上传失败，最多上传 5 个文件": "上傳失敗，最多上傳 5 個文件",
	"上传失败，请上传word、excel、pdf文件": "上傳失敗，請上傳 word、excel、pdf 文件",
	"新增随行人员": "新增隨行人員",
	"名片识别新增": "名片識別新增",
	"新增历史人员": "新增歷史人員",
	"手动填写新增": "手動填寫新增",
	"请添加报名人员": "請添加報名人員",
	"所属机构": "所屬機構",
	"职位": "職位",
	"联系方式": "聯繫方式",
	"电子邮箱": "電子郵箱",
	"确定要删除该随行人员吗？": "確定要刪除該隨行人員嗎？",
	"姓名和手机号不能为空": "姓名和手機號不能為空",
	"所属机构不能为空": "所屬機構不能為空",
	"职位不能为空": "職位不能為空",
	"邮件不能为空": "郵件不能為空",
	"参会者和随行人员之中存在手机号重复": "參會者和隨行人員之中存在手機號重複",
	"没有更多了": "沒有更多了",
	"正在识别": "正在識別",
	"请输入姓名": "請輸入姓名",
	"请输入机构": "請輸入機構",
	"请输入职位": "請輸入職位",
	"请输入联系电话": "請輸入聯繫電話",
	"请输入邮箱": "請輸入郵箱",
	"删除人员": "刪除人員",
	"代报名成功": "代報名成功",
	"请输入调研事由或您希望交流的内容": "請輸入調研事由或您希望交流的內容",
	"活动时长": "活動時長",
	"调研时间": "調研時間",
	"调研地址": "調研地址",
	"请选择调研地址": "請選擇調研地址",
	"调研人员": "調研人員",
	"分钟": "分鐘",
	"请输入联系方式": "請輸入聯繫方式",
	"请输入电子邮箱": "請輸入電子郵箱",
	"请确保名片信息准确无误，上传后将智能识别信息并填充": "請確保名片信息準確無誤，上傳後將智能識別信息並填充",
	"邀约卡片失效": "邀約卡片失效",
	"会议 ID": "會議 ID",
	"长按图片保存至相册": "長按圖片保存至相冊",
	"如长按图片无法保存可复制链接到浏览器打开页面操作": "如長按圖片無法保存可複製鏈接至瀏覽器打開頁面操作",
	"选填": "選填",

	"重发": '重發',
	"已向": '已向',
	"发送确认电子邮件，请注意查收": "發送確認電子郵件，請注意查收",
	"未收到电子邮件?点击此处": "未收到電子郵件？點擊此處",
	"会议正在进行": "會議正在進行",
	"距离会议开始": "距離會議開始",
	"本次路演为机构通路演，您还未通过机构用户认证": "本次路演為機构通路演，您還未通過機构用戶認證",
	"机构通认证未通过": "機构通認證未通過",
	"机构通认证通过": "機构通認證通過",
	"本次路演为专场路演，请按主办方要求获取权限": "本次路演為專場路演，請按主辦方要求獲取許可權",
	"添加日历": "添加日曆",
	"报名审核已通过，请至会议地点进行参会": '報名審核已通過，請至會議地點進行參會',
	"报名审核已通过，请准时参会": '報名審核已通過，請準時參會',
	"该场会议的报名人数已达上限": '該場會議的報名人數已達上限',
	"名字": "名字",
	"姓氏": "姓氏",
	"上传中": '上傳中',
	"上传失败，文件大小不能超过200M": "上傳失敗，文件大小不能超過200M",
	"提问成功": "提問成功",
	"加入会议": "加入會議",
	"报名通过": "報名通過",
	"本地日历": "本地日曆",
	"本场路演需报名审核通过才能参会": "本場路演需報名審核通過才能參會",
	"名字未填写，请填写后再进行提交": "名字未填寫，請填寫後再進行提交",
	"姓氏未填写，请填写后再进行提交": "姓氏未填寫，請填寫後再進行提交",
	"请输入真实姓氏": "請輸入真實姓氏",
	"请输入真实名字": "請輸入真實名字",
	"审核结果将以短信的形式通知,请留意": "審核結果將以簡訊的形式通知,請留意",
	"登记失败，同一邮箱每日每场会最多登记3次": "登記失敗，同一郵箱每日每場會最多登記3次",
	"报名审核成功后，您将收到关于加入会议的信息确认电子邮件，可通过邮件快速入会": "報名審核成功後，您將收到關於加入會議的信息確認電子郵件，可通過郵件快速入會",
	"发送参会确认电子邮件，请注意查收": "已向 {email} 發送參會確認電子郵件，請注意查收",

	'所属部门': '所屬部門',
	"请输入所属部门": "請輸入所屬部門",
	"添加至": "添加至",
	"进门提供技术支持": '進門提供技術支持',
	"应主办方要求，本次路演未保留回放": "應主辦方要求，本次路演未保留回放",
	"*上传名片后将自动填充个人信息": "*上傳名片後將自動填充個人信息",
	"请输入正确的邮箱": "請輸入正確的郵箱",
	"请添加签名": "請添加簽名",
	"请阅读并同意承诺书": "請閱讀並同意承諾書",
	"这是必填项": "這是必填項",
	"请上传名片/有效证件": "請上傳名片/有效證件",
	"预提问时间已截止，您可参会进行提问": "預提問時間已截止，您可參會進行提問",
	"查看会议": "查看會議",

	submitTipText: {
		"login": "請先<span>登入</span>後參與本場會議",
		//先報名
		"apply": "本場路演需<span>報名</span>審核通過才能參會",
		"applyRecord": "本場路演需<span>報名</span>審核通過才能觀看",
		//先認證
		"certification": "本場路演需完成<span>機構投資者認證</span>才能參會",
		"certificationRecord": "本場路演需完成<span>機構投資者認證</span>才能觀看",
		//白名單
		"whiteList": "本場路演僅<span>白名單</span>用戶才能參會",
		"whiteListRecord": "本場路演僅<span>白名單</span>用戶才能觀看",
		//購買專欄
		"buyColumn": "本場路演需購買<span>專欄</span>後才能觀看",
		// App
		"app": "應小程式要求，該路演請前往<span>往進門財經APP</span>觀看",
		//買會員
		"buyMember": "本場路演需購買<span>會員</span>後才能觀看",
		//購買課程
		"buyCourse": "本場路演需購買<span>課程</span>後才能觀看",
	},
	'活动日期': '活動日期',
	'活动时间': '活動時間',
	'亲爱的投资者': '親愛的投資者',
	'感谢您的关注与支持!': '感謝您的關註與支持!',
	'期待您的莅临': '期待您的蒞臨',
	'机构': '機構',
	'审批通过': '審批通過',
	'邀请函是您的参会凭证，请长按将邀请函保存至相册': '邀請函是您的參會憑證，請長按將邀請函保存至相冊',
	'境内拨入': '境内撥入',
	'境外/海外拨入': '境外/海外撥入'
}